import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./react-datepicker-override.css";

export const LabledDate = ({
	needsFill = false,
	className = "",
	label = "",
	value,
	onChange = () => null,
	placeholder = "",
	required = false,
}) => {
	const inputClass = `shadow-sm appearance-none border ${
		needsFill ? "border-red-600" : "border-gray-300 hover:border-gray-500"
	}  text-sm text-gray-700 rounded w-full h-auto py-2 px-3 font-light leading-tight focus:outline-none focus:border-gray-500`;

	return (
		<div className={`${className}`}>
			{label && (
				<label
					className={`block select-none font-medium text-sm mb-1 ${
						needsFill ? "text-red-600" : "text-black"
					}`}
				>
					{label}
					{required && <span className="text-red-600 ml-0.5">*</span>}
				</label>
			)}
			<input
				className={inputClass}
				value={value}
				onChange={onChange}
				type="date"
			></input>
		</div>
	);
};
